import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ShopService } from '../../services/shop.service';
import { AuthService } from '../../services/auth.service';
import Swal from 'sweetalert2';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Md5 } from 'md5-typescript';
import { ProductosService } from 'src/app/services/productos.service';
import { FletesService } from 'src/app/services/fletes.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-request',
  templateUrl: './request.component.html',
  styleUrls: ['./request.component.scss']
})
export class RequestComponent implements OnInit {

  @ViewChild('sectionSubscribe', { static: true }) sectionSubscribeDiv: ElementRef;

  pago = false;
  numCertificacion: string;
  medio: string;
  comprobante: string;

  fleteActivo = false;

  checkOn = false;
  cont = 0;
  confirmado = false;
  datos: any;
  compras: any;
  idUser: string;
  perfilUser: any;
  email: string;
  subtotal: number;
  descuento: number;
  liquidacion: number;
  city: string;

  sales: any = {
    cliente: [],
    compras: [],
    fecha: new Date().getTime(),
    idCliente: '',
    estado: 'Pendiente',
    pago: '',
    refCompra: '',
    total: 0,
    flete: 0,
    comprobante: ''
  };

  apiKey = '4X55k7DqamYNM2h2QeUpY18Z6F';
  merchantid = '880301';
  accountId = '888040';
  cifrado: string;
  moneda = 'COP';
  reference: number;

  ciudadesList: any;
  citySelection: any;
  precioFlete: number;
  lqd: number;

  produVerification: any;
  prds = 0;

  deliveryForm = new FormGroup ({
    nombre: new FormControl('', Validators.required),
    tipodocumento: new FormControl('', Validators.required),
    numero: new FormControl('', Validators.required),
    telefono: new FormControl('', [Validators.required, Validators.minLength(7)]),
    departamento: new FormControl('', Validators.required),
    ciudad: new FormControl('', Validators.required),
    direccion: new FormControl('', Validators.required)
  });

  get nombreNoValido() {
    return this.deliveryForm.get('nombre').invalid && this.deliveryForm.get('nombre').touched;
  }
  get tipodocumentoNoValido() {
    return this.deliveryForm.get('tipodocumento').invalid && this.deliveryForm.get('tipodocumento').touched;
  }
  get numeroNoValido() {
    return this.deliveryForm.get('numero').invalid && this.deliveryForm.get('numero').touched;
  }
  get telefonoNoValido() {
    return this.deliveryForm.get('telefono').invalid && this.deliveryForm.get('telefono').touched;
  }
  get departamentoNoValido() {
    return this.deliveryForm.get('departamento').invalid && this.deliveryForm.get('departamento').touched;
  }
  get ciudadNoValido() {
    return this.deliveryForm.get('ciudad').invalid && this.deliveryForm.get('ciudad').touched;
  }
  get direccionNoValido() {
    return this.deliveryForm.get('direccion').invalid && this.deliveryForm.get('direccion').touched;
  }

  private initValuesForm(){
    this.deliveryForm.patchValue({
      nombre: this.datos.datos.nombre,
      telefono: this.datos.datos.telefono,
      direccion: this.datos.datos.direccion
    });
  }

  constructor(private shopSvc: ShopService,
              private authSvc: AuthService,
              private prodSvc: ProductosService,
              private fleteSvc: FletesService,
              private router: Router) { }

  ngOnInit(): void {
    this.scrollToSubscribe();
    this.loadStorage();
    this.ciudadesList = this.fleteSvc.departamentosList;
    // console.log(this.ciudadesList);
  }

  scrollToSubscribe(){
    this.sectionSubscribeDiv.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  ngAfterViewInit(): void {
    this.authSvc.loadInfoUser()
               .subscribe(usr => {
                 this.datos = usr;
                 this.email = this.datos.email;
                 this.idUser = this.datos.id;
                 this.initValuesForm();
               });
  }

  loadStorage(){
    if (localStorage.getItem('dataCarShopTorreonMarket')) {
      this.compras = JSON.parse( localStorage.getItem('dataCarShopTorreonMarket'));
      this.calcularCosto();
    }
  }

  deleteCar(){
    localStorage.removeItem('dataCarShopTorreonMarket');
  }

  seleccionaDepartamento(departamento: string){
    for (const key in this.ciudadesList){
      if (this.ciudadesList[key].nombre === departamento) {
        this.citySelection = this.ciudadesList[key].ciudades;
      }
    }
  }

  seleccionaCiudad(ciudad: string){
    this.city = ciudad;
    if (ciudad === 'pereira') {
      Swal.fire('Pereira!', 'Si la dirección corresponde a zonas retiradas como Cerritos, Combia, Galicia, El Tigre, La Florida, Mundo Nuevo, Vía Armenia, San Joaquín o Aledaños, por favor seleccione Pereira-extra', 'success');
    }
    if (ciudad === 'pereira-extra') {
      Swal.fire('Pereira - Extra!', 'Si la dirección corresponde a zonas retiradas como Cerritos, Combia, Galicia, El Tigre, La Florida, Mundo Nuevo, Vía Armenia, San Joaquín o Aledaños, por favor seleccione Pereira-extra, de no ser así, debes seleccionar Pereira', 'success');
    }
    this.liquidarFlete(ciudad);
    this.lqd = this.liquidacion + this.precioFlete;
  }

  calcularCosto(){
    let idPr = '';
    let cantProducto = 0;
    let saldo = 0;
        let descuent = 0;
        let ttal = 0;
        for (const key in this.compras){
          saldo = parseInt(this.compras[key].subtotal) + saldo;
          descuent = (parseInt(this.compras[key].subtotal) * parseInt(this.compras[key].descuento)/100) + descuent;
          ttal = parseInt(this.compras[key].total) + ttal;
          idPr = this.compras[key].idprod;
          cantProducto = this.compras[key].cantidad;
          this.verificaInventario(idPr, cantProducto, this.prds);
        }
        // se verifica cuanto producto sin inventario hay en el pedido
        // console.log(this.prds);
        if (this.prds > 0) {
          Swal.fire('No hay suficiente inventario para este pedido, por favor revise cantidades disponibles por cada producto');
        }

        this.subtotal = saldo;
        this.descuento = descuent;
        this.liquidacion = ttal;
  }

  verificaInventario(idProducto: string, cantProd: number, contador: number){
    this.prodSvc.loadProductById(idProducto)
                .subscribe(res => {
                  this.produVerification = res;
                  // console.log('Verificacion de  productos: ', this.produVerification.cantidad);
                  if (this.produVerification.cantidad > cantProd) {
                    contador++;
                  }
                })
  }

  borrarProducto(compra){
    Swal.fire({
      title: 'Está seguro?',
      text: `Se eliminará definitivamente este producto del carrito!`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si, borrarlo!',
      cancelButtonText: "Cancelar",
    }).then(result => {
      if (result.value) {
        this.compras.splice(compra, 1);
        this.calcularCosto();
        this.seleccionaCiudad(this.city);
        //this.lqd = this.liquidacion - this.precioFlete;
        //this.confirmado = false;
        localStorage.setItem('dataCarShopTorreonMarket', JSON.stringify(this.compras));
        this.prodSvc.cantCompras$ = this.compras.Length;
        Swal.fire('Eliminado!', 'El producto ha sido borrado, debes volver  confirmar datos para finalizar la compra', 'success');
      }
    });
  }

  infoUser(info: any){
    if (this.deliveryForm.invalid) {
      Swal.fire('Por favor completar todos los datos y dar click en botón Confirmar datos para que pueda completar su compra.');
      return;
    }
    if (this.subtotal >= 20000) {
      this.confirmado = true;
      this.authSvc.updateInfoUser(this.idUser, info)
                  .then(userInfo => {
                    Swal.fire('Actualizado!', 'Se han confirmado los datos de entrega.', 'success');
                  });
    } else {
      Swal.fire('El pedido mínimo debe ser de $20.000');
      return;
    }
  }

  //<input name="responseUrl" type="hidden" value="https://torreonmarket-25713.web.app/#/confirmacion">

  payu(){
    if (!this.confirmado) {
      Swal.fire('Debe confirmar sus datos de entrega y aceptar términos y condiciones para continuar');
      return;
    }
    if (this.prds > 0) {
      Swal.fire('No hay suficiente inventario para este pedido, por favor revise cantidades disponibles por cada producto');
      return;
    }
    if (this.checkOn) {
      this.sales.cliente = this.datos.datos;
      this.sales.compras = this.compras;
      this.sales.idCliente = this.idUser;
      this.sales.pago = 'PayU';
      this.sales.total = this.lqd;
      this.sales.flete = this.precioFlete;
      this.reference = Math.ceil(Math.random() * 987524);
      this.sales.refCompra = this.reference;
      this.sales.comprobante = 'N/A'
      const signature = Md5.init(`${this.apiKey}~${this.merchantid}~${this.reference}~${this.lqd}~COP`);
      const pasarela = `
    <img src="../../../assets/img/logo_payu.png" alt="" width="90">
    <form method="post" action="https://checkout.payulatam.com/ppp-web-gateway-payu">
      <input name="merchantId"      type="hidden"  value="${this.merchantid}" >
      <input name="accountId"       type="hidden"  value="${this.accountId}" >
      <input name="description"     type="hidden"  value="Pago TORREÓN MARKET"  >
      <input name="referenceCode"   type="hidden"  value="${this.reference}" >
      <input name="amount"          type="hidden"  value="${this.lqd}"   >
      <input name="tax"             type="hidden"  value="0"  >
      <input name="taxReturnBase"   type="hidden"  value="0" >
      <input name="currency"        type="hidden"  value="COP" >
      <input name="signature"       type="hidden"  value="${signature}"  >
      <input name="test"            type="hidden"  value="0" >
      <input name="buyerEmail"      type="hidden"  value="${this.email}" >
      <input name="responseUrl"     type="hidden"  value="https://torreonmarket.com/#/confirmacion" >
      <input name="confirmationUrl" type="hidden"  value="http://www.test.com/confirmation" >
      <input name="Submit"          type="submit"  value="Enviar" >
    </form>`;
      const fecha = new Date().getTime();
      const medio = 'PayU';
      const estado = 'Procesandose';
      const refer = this.reference;
      this.shopSvc.sailProcess(this.sales).then(res => {
        Swal.fire({
          title: 'Realizar pago',
          icon: 'info',
          html: pasarela,
          showConfirmButton: false,
          showCancelButton: true,
          cancelButtonColor: '#d46767',
          cancelButtonText: "Cancelar",
          });
        this.deleteCar();
    }).catch(err => {
      Swal.fire({
      title: 'Error...',
      text: 'Algo salió mal!!!',
      icon: 'error',
      allowOutsideClick: false,
      showCloseButton: true
      });
    });
  } else {
      Swal.fire({
        title: 'Error...',
        text: 'Debes aceptar términos y condiciones para la compra',
        icon: 'error',
        allowOutsideClick: false,
        showCloseButton: true
        });
    }
  }

  bancolombia(){
    if (!this.confirmado || !this.checkOn) {
      Swal.fire('Debe confirmar sus datos de entrega y aceptar términos y condiciones para continuar');
      return;
    }  
    this.sales.cliente = this.datos.datos;
    this.sales.compras = this.compras;
    this.sales.idCliente = this.idUser;
    this.sales.pago = 'Bancolombia';
    this.sales.total = this.lqd;
    this.sales.flete = this.precioFlete;
    this.reference = Math.ceil(Math.random() * 987524);
    this.sales.refCompra = this.reference;
    this.pago = true;
    this.numCertificacion = 'Ingrese el número de comprobante';
    this.medio = 'bancolombia';
  }
  daviplata(){
    if (!this.confirmado || !this.checkOn) {
      Swal.fire('Debe confirmar sus datos de entrega y aceptar términos y condiciones para continuar');
      return;
    }
    this.sales.cliente = this.datos.datos;
    this.sales.compras = this.compras;
    this.sales.idCliente = this.idUser;
    this.sales.pago = 'Daviplata';
    this.sales.total = this.lqd;
    this.sales.flete = this.precioFlete;
    this.reference = Math.ceil(Math.random() * 987524);
    this.sales.refCompra = this.reference;

    this.pago = true;
    this.numCertificacion = 'Ingrese el número de confirmación';
    this.medio = 'daviplata';
    console.log(this.sales);
  }

  compra(){
    if (this.comprobante) {
      this.shopSvc.sailProcess(this.sales).then(() => {
        this.deleteCar();
        Swal.fire('Compra enviada correctamente');
        this.router.navigate(['/info']);       
      });
    } else {
      Swal.fire('Por favor indique el número de comprobante de su transacción');
      return;
    }
  }

  check(event: any){
    if (this.cont === 0) {
      this.cont++;
      this.checkOn = true;
    } else if (this.cont > 0) {
      this.cont--;
      this.checkOn = false;
    }
  }

  liquidarFlete(ciudad: string){

    this.precioFlete = 0;
    if (this.confirmado && this.fleteActivo) {
      this.confirmado = false;
      this.lqd = this.liquidacion;
    }

    if (this.liquidacion >= 20000 && this.liquidacion < 50000) {
      if (ciudad === 'bogota' || ciudad === 'soacha' || ciudad === 'apartado' || ciudad === 'turbo' || ciudad === 'rionegro' || ciudad === 'caucasia' || ciudad === 'bucaramanga' || ciudad === 'floridablanca' || ciudad === 'giron' || ciudad === 'barrancabermeja' || ciudad === 'piedecuesta' || ciudad === 'pasto' || ciudad === 'tumaco' || ciudad === 'riohacha' || ciudad === 'maicao' || ciudad === 'barranquilla' || ciudad === 'soledad' || ciudad === 'yopal' || ciudad === 'villavicencio' || ciudad === 'santa marta' || ciudad === 'valledupar' || ciudad === 'cartagena' || ciudad === 'cucuta' || ciudad === 'monteria' || ciudad === 'popayan' || ciudad === 'sincelejo' || ciudad === 'tunja' || ciudad === 'quibdo') {
        this.precioFlete = 12000;
        this.fleteActivo = true;

      }
      if (ciudad === 'medellin' || ciudad === 'itagui' || ciudad === 'envigado' || ciudad === 'bello' || ciudad === 'ibague' || ciudad === 'neiva' || ciudad === 'florencia' || ciudad === 'cali' || ciudad === 'buenaventura' || ciudad === 'palmira' || ciudad === 'tulua') {
        this.precioFlete = 9900;
        this.fleteActivo = true;

      }
      if (ciudad === 'alcala' || ciudad === 'ulloa' || ciudad === 'caicedonia' || ciudad === 'cartago' || ciudad === 'ansermanuevo' || ciudad === 'zaragoza' || ciudad === 'obando' || ciudad === 'chinchina' || ciudad === 'manizales' || ciudad === 'villamaria' || ciudad === 'viterbo' || ciudad === 'filandia' || ciudad === 'circasia' || ciudad === 'salento' || ciudad === 'armenia' || ciudad === 'calarca' || ciudad === 'montenegro'|| ciudad === 'quimbaya' || ciudad === 'la tebaida' || ciudad === 'pueblo tapao' || ciudad === 'la virginia' || ciudad === 'santa rosa de cabal') {
        this.precioFlete = 8500;
        this.fleteActivo = true;

      }
      if (ciudad === 'sevilla' || ciudad === 'la victoria' || ciudad === 'zarzal' || ciudad === 'la paila' || ciudad === 'roldanillo' || ciudad === 'la union' || ciudad === 'toro' || ciudad === 'anserma' || ciudad === 'riosucio' || ciudad === 'supia' || ciudad === 'barcelona' || ciudad === 'belen de umbria' || ciudad === 'guatica' || ciudad === 'quinchia'|| ciudad === 'marsella' ) {
        this.precioFlete = 9500;
        this.fleteActivo = true;

      }
    }
    if (this.liquidacion >= 90000) {
      if (ciudad === 'dosquebradas') {
        this.precioFlete = 0;
        this.fleteActivo = true;
        Swal.fire('El flete de su producto es gratuito');
      }
    }
    if (this.liquidacion >= 20000 && this.liquidacion < 50000) {
      if (ciudad === 'dosquebradas') {
        this.precioFlete = 7500;
        this.fleteActivo = true;

      }
    }
    if (this.liquidacion >= 50000 && this.liquidacion < 90000) {
      if (ciudad === 'dosquebradas') {
        this.precioFlete = 7800;
        this.fleteActivo = true;

      }
    }
    if (this.liquidacion >= 90000) {
      if (ciudad === 'pereira') {
        this.precioFlete = 0;
        this.fleteActivo = true;
        Swal.fire('El flete de su producto es gratuito');
      }
    }
    if (this.liquidacion >= 20000 && this.liquidacion < 50000) {
      if (ciudad === 'pereira') {
        this.precioFlete = 7200;
        this.fleteActivo = true;

      }
    }
    if (this.liquidacion >= 50000 && this.liquidacion < 90000) {
      if (ciudad === 'pereira') {
        this.precioFlete = 7500;
        this.fleteActivo = true;

      }
    }
    if (this.liquidacion >= 130000) {
      if (ciudad === 'pereira-extra') {
        this.precioFlete = 0;
        this.fleteActivo = true;
        Swal.fire('El flete de su producto es gratuito');
      }
    }
    if (this.liquidacion >= 20000 && this.liquidacion < 50000) {
      if (ciudad === 'pereira-extra') {
        this.precioFlete = 10000;
        this.fleteActivo = true;
      }
    }
    if (this.liquidacion >= 50000 && this.liquidacion < 90000) {
      if (ciudad === 'pereira-extra') {
        this.precioFlete = 10500;
        this.fleteActivo = true;

      }
    }
    if (this.liquidacion >= 90000 && this.liquidacion < 130000) {
      if (ciudad === 'pereira-extra') {
        this.precioFlete = 10900;
        this.fleteActivo = true;

      }
    }
    if (this.liquidacion >= 50000 && this.liquidacion < 90000) {
      if (ciudad === 'bogota' || ciudad === 'soacha' || ciudad === 'apartado' || ciudad === 'turbo' || ciudad === 'rionegro' || ciudad === 'caucasia' || ciudad === 'bucaramanga' || ciudad === 'floridablanca' || ciudad === 'giron' || ciudad === 'barrancabermeja' || ciudad === 'piedecuesta' || ciudad === 'pasto' || ciudad === 'tumaco' || ciudad === 'riohacha' || ciudad === 'maicao' || ciudad === 'barranquilla' || ciudad === 'soledad' || ciudad === 'yopal' || ciudad === 'villavicencio' || ciudad === 'santa marta' || ciudad === 'valledupar' || ciudad === 'cartagena' || ciudad === 'cucuta' || ciudad === 'monteria' || ciudad === 'popayan' || ciudad === 'sincelejo' || ciudad === 'tunja' || ciudad === 'quibdo') {
        this.precioFlete = 13900;

      }
      if (ciudad === 'medellin' || ciudad === 'itagui' || ciudad === 'envigado' || ciudad === 'bello' || ciudad === 'ibague' || ciudad === 'neiva' || ciudad === 'florencia' || ciudad === 'cali' || ciudad === 'buenaventura' || ciudad === 'palmira' || ciudad === 'tulua') {
        this.precioFlete = 12900;
        this.fleteActivo = true;

      }
      if (ciudad === 'alcala' || ciudad === 'ulloa' || ciudad === 'caicedonia' || ciudad === 'cartago' || ciudad === 'ansermanuevo' || ciudad === 'zaragoza' || ciudad === 'obando' || ciudad === 'chinchina' || ciudad === 'manizales' || ciudad === 'villamaria' || ciudad === 'viterbo' || ciudad === 'filandia' || ciudad === 'circasia' || ciudad === 'salento' || ciudad === 'armenia' || ciudad === 'calarca' || ciudad === 'montenegro'|| ciudad === 'quimbaya' || ciudad === 'la tebaida' || ciudad === 'pueblo tapao' || ciudad === 'la virginia' || ciudad === 'santa rosa de cabal') {
        this.precioFlete = 8900;
        this.fleteActivo = true;

      }
      if (ciudad === 'sevilla' || ciudad === 'la victoria' || ciudad === 'zarzal' || ciudad === 'la paila' || ciudad === 'roldanillo' || ciudad === 'la union' || ciudad === 'toro' || ciudad === 'anserma' || ciudad === 'riosucio' || ciudad === 'supia' || ciudad === 'barcelona' || ciudad === 'belen de umbria' || ciudad === 'guatica' || ciudad === 'quinchia'|| ciudad === 'marsella' ) {
        this.precioFlete = 9900;
        this.fleteActivo = true;

      }
    }
    if (this.liquidacion >= 90000 && this.liquidacion < 130000) {
      if (ciudad === 'bogota' || ciudad === 'soacha' || ciudad === 'apartado' || ciudad === 'turbo' || ciudad === 'rionegro' || ciudad === 'caucasia' || ciudad === 'bucaramanga' || ciudad === 'floridablanca' || ciudad === 'giron' || ciudad === 'barrancabermeja' || ciudad === 'piedecuesta' || ciudad === 'pasto' || ciudad === 'tumaco' || ciudad === 'riohacha' || ciudad === 'maicao' || ciudad === 'barranquilla' || ciudad === 'soledad' || ciudad === 'yopal' || ciudad === 'villavicencio' || ciudad === 'santa marta' || ciudad === 'valledupar' || ciudad === 'cartagena' || ciudad === 'cucuta' || ciudad === 'monteria' || ciudad === 'popayan' || ciudad === 'sincelejo' || ciudad === 'tunja' || ciudad === 'quibdo') {
        this.precioFlete = 19900;

      }
      if (ciudad === 'medellin' || ciudad === 'itagui' || ciudad === 'envigado' || ciudad === 'bello' || ciudad === 'ibague' || ciudad === 'neiva' || ciudad === 'florencia' || ciudad === 'cali' || ciudad === 'buenaventura' || ciudad === 'palmira' || ciudad === 'tulua') {
        this.precioFlete = 15900;
        this.fleteActivo = true;

      }
      if (ciudad === 'alcala' || ciudad === 'ulloa' || ciudad === 'caicedonia' || ciudad === 'cartago' || ciudad === 'ansermanuevo' || ciudad === 'zaragoza' || ciudad === 'obando' || ciudad === 'chinchina' || ciudad === 'manizales' || ciudad === 'villamaria' || ciudad === 'viterbo' || ciudad === 'filandia' || ciudad === 'circasia' || ciudad === 'salento' || ciudad === 'armenia' || ciudad === 'calarca' || ciudad === 'montenegro'|| ciudad === 'quimbaya' || ciudad === 'la tebaida' || ciudad === 'pueblo tapao' || ciudad === 'la virginia' || ciudad === 'santa rosa de cabal') {
        this.precioFlete = 11900;
        this.fleteActivo = true;

      }
      if (ciudad === 'sevilla' || ciudad === 'la victoria' || ciudad === 'zarzal' || ciudad === 'la paila' || ciudad === 'roldanillo' || ciudad === 'la union' || ciudad === 'toro' || ciudad === 'anserma' || ciudad === 'riosucio' || ciudad === 'supia' || ciudad === 'barcelona' || ciudad === 'belen de umbria' || ciudad === 'guatica' || ciudad === 'quinchia'|| ciudad === 'marsella' ) {
        this.precioFlete = 12900;
        this.fleteActivo = true;

      }
    }
    if (this.liquidacion >130000) {
      if (ciudad === 'bogota' || ciudad === 'soacha' || ciudad === 'apartado' || ciudad === 'turbo' || ciudad === 'rionegro' || ciudad === 'caucasia' || ciudad === 'bucaramanga' || ciudad === 'floridablanca' || ciudad === 'giron' || ciudad === 'barrancabermeja' || ciudad === 'piedecuesta' || ciudad === 'pasto' || ciudad === 'tumaco' || ciudad === 'riohacha' || ciudad === 'maicao' || ciudad === 'barranquilla' || ciudad === 'soledad' || ciudad === 'yopal' || ciudad === 'villavicencio' || ciudad === 'santa marta' || ciudad === 'valledupar' || ciudad === 'cartagena' || ciudad === 'cucuta' || ciudad === 'monteria' || ciudad === 'popayan' || ciudad === 'sincelejo' || ciudad === 'tunja' || ciudad === 'quibdo') {
        this.precioFlete = 25900;

      }
      if (ciudad === 'medellin' || ciudad === 'itagui' || ciudad === 'envigado' || ciudad === 'bello' || ciudad === 'ibague' || ciudad === 'neiva' || ciudad === 'florencia' || ciudad === 'cali' || ciudad === 'buenaventura' || ciudad === 'palmira' || ciudad === 'tulua') {
        this.precioFlete = 20900;
        this.fleteActivo = true;

      }
      if (ciudad === 'alcala' || ciudad === 'ulloa' || ciudad === 'caicedonia' || ciudad === 'cartago' || ciudad === 'ansermanuevo' || ciudad === 'zaragoza' || ciudad === 'obando' || ciudad === 'chinchina' || ciudad === 'manizales' || ciudad === 'villamaria' || ciudad === 'viterbo' || ciudad === 'filandia' || ciudad === 'circasia' || ciudad === 'salento' || ciudad === 'armenia' || ciudad === 'calarca' || ciudad === 'montenegro'|| ciudad === 'quimbaya' || ciudad === 'la tebaida' || ciudad === 'pueblo tapao' || ciudad === 'la virginia' || ciudad === 'santa rosa de cabal') {
        this.precioFlete = 14900;
        this.fleteActivo = true;

      }
      if (ciudad === 'sevilla' || ciudad === 'la victoria' || ciudad === 'zarzal' || ciudad === 'la paila' || ciudad === 'roldanillo' || ciudad === 'la union' || ciudad === 'toro' || ciudad === 'anserma' || ciudad === 'riosucio' || ciudad === 'supia' || ciudad === 'barcelona' || ciudad === 'belen de umbria' || ciudad === 'guatica' || ciudad === 'quinchia'|| ciudad === 'marsella' ) {
        this.precioFlete = 15900;
        this.fleteActivo = true;

      }
    }
    //console.log(ciudad, '-', this.liquidacion, '-', this.precioFlete);
  }
}


